// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-image-lightbox/style.css';

import React, { useLayoutEffect, useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import Lightbox from 'react-image-lightbox';

import { GalleryContainer, GalleryItem } from './LightboxGallery.styled';

interface LightboxGalleryProps {
    urls: string[];
}

export const LightboxGallery: React.FC<LightboxGalleryProps> = ({ urls }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  useLayoutEffect(() => {
    if (isOpen) {
      // wywołaj w nextTick, żeby DOM zdążył zamontować portal
      requestAnimationFrame(() => {
        window.dispatchEvent(new Event('resize'));
      });
    }
  }, [isOpen]);

  if (urls.length === 0) return null;
  return (
    <>
      <GalleryContainer>
        {urls.map((src, idx) => (
          <GalleryItem
              /* eslint-disable-next-line react/no-array-index-key */
            key={idx}
            src={src}
            alt={`Miniatura ${idx + 1}`}
            /* eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role */
            role="button"
            tabIndex={0}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setPhotoIndex(idx);
              setIsOpen(true);
            }}
          />
        ))}
      </GalleryContainer>

      {isOpen && (
      <Lightbox
        mainSrc={urls[photoIndex]}
        nextSrc={urls[(photoIndex + 1) % urls.length]}
        prevSrc={urls[(photoIndex + urls.length - 1) % urls.length]}
        onCloseRequest={() => setIsOpen(false)}
        onMovePrevRequest={() => setPhotoIndex((photoIndex + urls.length - 1) % urls.length)}
        onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % urls.length)}
        animationDisabled
      />
      )}
    </>
  );
};
